// File: frontend/src/actions/sectionsActions.js

import { getSectionApiRoot } from '../utils/sectionsMediaApi';

export const FETCH_SECTION_MESSAGES = 'FETCH_SECTION_MESSAGES';
export const FETCH_SECTION_MESSAGES_BY_CITY = 'FETCH_SECTION_MESSAGES_BY_CITY';
export const FILTER_SECTION_MESSAGES_BY_CITY = 'FILTER_SECTION_MESSAGES_BY_CITY';
const SECTION_SITE_KEY = process.env.REACT_APP_CULTUREL_SITE_KEY || '';

/**
 * Récupère les messages d'une catégorie depuis le backend locale.
 */
export const fetchSectionMessages = (categ = 'culturel') => {
  return async dispatch => {
    try {
      const siteKeyParam = SECTION_SITE_KEY
        ? `&siteKey=${encodeURIComponent(SECTION_SITE_KEY)}`
        : '';

      const root = getSectionApiRoot(categ);
      const response = await fetch(`${root}/messages/?categ=${encodeURIComponent(categ)}${siteKeyParam}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }
      
      const data = await response.json();
      dispatch({ 
        type: FETCH_SECTION_MESSAGES, 
        payload: data 
      });
    } catch (error) {
      console.error('❌ Erreur lors de la récupération des contenus de section:', error);
      dispatch({ 
        type: FETCH_SECTION_MESSAGES, 
        payload: [] 
      });
    }
  };
};

/**
 * Filtre les messages de section par ville (lyon, paris, marseille)
 */
export const filterSectionMessagesByCity = (city) => {
  return {
    type: FILTER_SECTION_MESSAGES_BY_CITY,
    payload: city
  };
};
